export class ImageResizeManager {
	static async loadAndResizeImage(url, width) {
		if (!url) {
			return null
		}

		return new Promise((resolve, reject) => {
			const img = new Image()
			img.crossOrigin = 'Anonymous'
			img.src = url

			img.onload = () => {
				this.resizeImage(img, width)
					.then(blob => {
						resolve(blob)
					})
					.catch(error => {
						console.error('Error during resizing process:', error)
						reject(error)
					})
			}

			img.onerror = (error) => {
				console.error('Failed to load image for resizing:', url)
				reject(error)
			}
		})
	}

	static resizeImage(image, minWidth) {
		return new Promise((resolve, reject) => {            
			const scale = 0.5

			let canvas = document.createElement('canvas')
			let ctx = canvas.getContext('2d')
            
			canvas.width = image.width
			canvas.height = image.height

			while (canvas.width * scale >= minWidth) {
				canvas.width = canvas.width * scale
				canvas.height = canvas.height * scale
			}

		    ctx.drawImage(image, 0, 0, canvas.width, canvas.height)

			canvas.toBlob((blob) => {
				if (blob) {
					resolve(blob)
				} else {
					reject(new Error('Blob conversion failed'))
				}
			}, 'image/jpeg', 1)
		})
	}
}
